import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SellerServices from '../../services/SallerServices';
import UserServices from '../../services/UserServices';
function AddPass() {
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState({
        name: '',
        category: '',
        description: '',
        image: '',
        venue: '',
        address: '',

        state: '',
        stateName: '',
        city: '',
        cityName: '',

        startDate: '',
        startTime: '',
        endDate: '',
        endTime: '',
        status: 'Active'
    });

    const [loading, setLoading] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);;
    const [loadingCities, setLoadingCities] = useState(false);
    // ✅ handle input
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'stateName') {
            const selectedState = stateList.find(s => s.name === value);
            setFormValues(prev => ({
                ...prev,
                stateName: value,
                state: selectedState?._id || '',
                cityName: '',
                city: ''
            }));
            setCityList([]);
            if (selectedState?._id) {
                setLoadingCities(true);
                UserServices.getCities(selectedState._id)
                    .then(res => {
                        if (res.status && res.data) {
                            setCityList(res.data);
                        }
                    })
                    .catch(err => console.error(err))
                    .finally(() => setLoadingCities(false));
            }

        } else if (name === 'cityName') {
            const selectedCity = cityList.find(c => c.name === value);
            setFormValues(prev => ({
                ...prev,
                cityName: value,
                city: selectedCity?._id || ''
            }));

        }
        else if
            (name === 'mobileNo') {
            const onlyNumber = value.replace(/\D/g, '');

            if (onlyNumber.length <= 10) {
                setFormValues(prev => ({
                    ...prev,
                    mobileNo: onlyNumber
                }));
            }
        }


        else {
            setFormValues(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };
    useEffect(() => {
        // Fetch states on component mount
        UserServices.getState().then(res => {
            console.log("States response:", res);
            if (res.status && res.data) {
                setStateList(res.data);
            }
        }).catch(error => {
            console.error("Error fetching states:", error);
        });
    }, []);
    // ✅ handle image
    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            setFormValues((prev) => ({
                ...prev,
                image: file
            }));
            setImagePreview(URL.createObjectURL(file));
        }
    };
    const handleMobileChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');

        if (value.length <= 10) {
            setFormValues(prev => ({
                ...prev,
                mobileNo: value
            }));
        }
    };
    // ✅ validation
    const validateForm = () => {

        if (!formValues.name.trim()) {
            alert("Event name required");
            return false;
        }

        if (!formValues.category) {
            alert("Event category required");
            return false;
        }

        if (!formValues.description.trim()) {
            alert("Event description required");
            return false;
        }

        if (!formValues.venue.trim()) {
            alert("Venue required");
            return false;
        }

        if (!formValues.address.trim()) {
            alert("Address required");
            return false;
        }

        if (!formValues.city.trim()) {
            alert("City required");
            return false;
        }

        if (!formValues.startDate) {
            alert("Start date required");
            return false;
        }

        if (!formValues.startTime) {
            alert("Start time required");
            return false;
        }

        if (!formValues.endDate) {
            alert("End date required");
            return false;
        }

        if (!formValues.endTime) {
            alert("End time required");
            return false;
        }


        // End date/time start se pehle nahi hona chahiye
        const startDateTime = new Date(
            `${formValues.startDate}T${formValues.startTime}`
        );

        const endDateTime = new Date(
            `${formValues.endDate}T${formValues.endTime}`
        );

        if (endDateTime <= startDateTime) {

            alert(
                "End date/time must be after start date/time"
            );

            return false;
        }

        return true;
    };

    // ✅ submit
    const handleSubmit = async (event) => {
        event.preventDefault();
        // if (!validateForm()) return;
        setLoading(true);
        try {
            const formData = new FormData();
            Object.keys(formValues).forEach((key) => {
                formData.append(key, formValues[key]);
            });
            const res = await SellerServices.createSeller(formData);
            //    alert("Seller created successfully 🎉");
            //     navigate("/sallers");
            if (res?.status) {
                alert(res?.message);
                navigate("/passes-list");
            } else {
                alert(res?.message);
            }

        } catch (error) {
            console.error("Error:", error);
            alert(error.response?.data?.message || "Failed to create seller");
        } finally {
            setLoading(false);
        }
    };

    // ✅ cleanup image memory
    useEffect(() => {
        return () => {
            if (imagePreview) URL.revokeObjectURL(imagePreview);
        };
    }, [imagePreview]);

    return (
        <>
            <div className="right_col" role="main">
                <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
                    <div className="my-auto">
                        <h5 className="page-title fs-21 mb-1">
                            Add New Pass
                        </h5>

                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <a href="javascript:void(0);">
                                        Home
                                    </a>
                                </li>
                            </ol>
                        </nav>
                    </div>

                    <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
                        <Link
                            className="list-banner-btn"
                            to="/passes-list"
                        >
                            Passes List
                        </Link>
                    </div>
                </div>

                <div className="container-box">
                    <div className="container-box-inner table-reponsive-tabe">
                        <div className="page-details">

                            <form onSubmit={handleSubmit}>

                                <div className="row">

                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">

                                            <label>
                                                Pass Name
                                                <span className="red">*</span>
                                            </label>

                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control"
                                                value={formValues.name}
                                                onChange={handleInputChange}
                                                placeholder="Enter event name"
                                            />

                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">

                                            <label>
                                                Event Category
                                                <span className="red">*</span>
                                            </label>

                                            <select
                                                name="category"
                                                className="form-control"
                                                value={formValues.category}
                                                onChange={handleInputChange}
                                            >

                                                <option value="">
                                                    Select Category
                                                </option>

                                                <option value="Music">
                                                    Music
                                                </option>

                                                <option value="Comedy">
                                                    Comedy
                                                </option>

                                                <option value="Sports">
                                                    Sports
                                                </option>

                                                <option value="Food">
                                                    Food
                                                </option>

                                                <option value="Conference">
                                                    Conference
                                                </option>

                                                <option value="Other">
                                                    Other
                                                </option>

                                            </select>

                                        </div>
                                    </div>
                                 


                           
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">

                                            <label>
                                                State
                                                <span className="red">*</span>
                                            </label>

                                            <select
                                                name="stateName"
                                                className="form-control"
                                                value={formValues.stateName}
                                                onChange={handleInputChange}
                                            >

                                                <option value="">
                                                    Select State
                                                </option>

                                                {stateList.map((state) => (
                                                    <option
                                                        key={state._id}
                                                        value={state.name}
                                                    >
                                                        {state.name}
                                                    </option>
                                                ))}

                                            </select>

                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">

                                            <label>
                                                City
                                                <span className="red">*</span>
                                            </label>

                                            <select
                                                name="cityName"
                                                className="form-control"
                                                value={formValues.cityName}
                                                onChange={handleInputChange}
                                                disabled={!formValues.state || loadingCities}
                                            >

                                                <option value="">
                                                    {loadingCities
                                                        ? "Loading cities..."
                                                        : "Select City"
                                                    }
                                                </option>

                                                {cityList.map((city) => (
                                                    <option
                                                        key={city._id}
                                                        value={city.name}
                                                    >
                                                        {city.name}
                                                    </option>
                                                ))}

                                            </select>

                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">

                                            <label>
                                                Address
                                                <span className="red">*</span>
                                            </label>

                                            <input
                                                type="text"
                                                name="address"
                                                className="form-control"
                                                value={formValues.address}
                                                onChange={handleInputChange}
                                                placeholder="Enter event address"
                                            />

                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-sm-6">
                                        <div className="input-field">

                                            <label>
                                                Start Date
                                                <span className="red">*</span>
                                            </label>

                                            <input
                                                type="date"
                                                name="startDate"
                                                className="form-control"
                                                value={formValues.startDate}
                                                onChange={handleInputChange}
                                            />

                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-sm-6">
                                        <div className="input-field">

                                            <label>
                                                Start Time
                                                <span className="red">*</span>
                                            </label>

                                            <input
                                                type="time"
                                                name="startTime"
                                                className="form-control"
                                                value={formValues.startTime}
                                                onChange={handleInputChange}
                                            />

                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-sm-6">
                                        <div className="input-field">

                                            <label>
                                                End Date
                                                <span className="red">*</span>
                                            </label>

                                            <input
                                                type="date"
                                                name="endDate"
                                                className="form-control"
                                                value={formValues.endDate}
                                                onChange={handleInputChange}
                                            />

                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-sm-6">
                                        <div className="input-field">

                                            <label>
                                                End Time
                                                <span className="red">*</span>
                                            </label>

                                            <input
                                                type="time"
                                                name="endTime"
                                                className="form-control"
                                                value={formValues.endTime}
                                                onChange={handleInputChange}
                                            />

                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">

                                            <label>
                                                Status
                                                <span className="red">*</span>
                                            </label>

                                            <select
                                                name="status"
                                                className="form-control"
                                                value={formValues.status}
                                                onChange={handleInputChange}
                                            >

                                                <option value="Active">
                                                    Active
                                                </option>

                                                <option value="Inactive">
                                                    Inactive
                                                </option>

                                            </select>

                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">

                                            <label>
                                                Event Image
                                            </label>

                                            <input
                                                type="file"
                                                className="form-control"
                                                accept="image/*"
                                                onChange={handleImageChange}
                                            />

                                            {imagePreview && (
                                                <div
                                                    style={{
                                                        marginTop: "10px"
                                                    }}
                                                >

                                                    <img
                                                        src={imagePreview}
                                                        alt="Event Preview"
                                                        style={{
                                                            width: "150px",
                                                            height: "150px",
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                            border: "1px solid #ccc"
                                                        }}
                                                    />

                                                </div>
                                            )}

                                        </div>
                                    </div>
                                     <div className="col-lg-12 col-sm-12">
                                        <div className="input-field">

                                            <label>
                                                Event Description
                                                <span className="red">*</span>
                                            </label>

                                            <textarea
                                                className="form-control video-desc"
                                                name="description"
                                                value={formValues.description}
                                                onChange={handleInputChange}
                                                placeholder="Enter event description"
                                            />

                                        </div>
                                    </div>


                                </div>
                                <div className="text-center mt-4">

                                    <button
                                        className="submit-green-btn"
                                        type="submit"
                                        disabled={loading}
                                        style={{
                                            minWidth: '150px'
                                        }}
                                    >

                                        {loading
                                            ? 'SUBMITTING...'
                                            : 'SUBMIT'
                                        }

                                    </button>

                                </div>

                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddPass;